import Icon from './Icon';
import { IconProps, IconValueProps, IconCombinedProps } from './types';

export type { IconProps, IconValueProps, IconCombinedProps };
export default Icon;
